module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/studio-suns_access_03-c6d4bd3637d16fc59252be8d9918e90d.jpg";